import React, { createContext, useContext, useState, ReactNode } from 'react';
import { SpotLockUser } from '../sp-types/userType';

type SessionStatus = 'loading' | 'unauthenticated' | 'authenticated';

type AppSessionState = {
  status: SessionStatus;
  user: SpotLockUser | null;
  firebaseReady: boolean;
  setSession: (status: SessionStatus, user: SpotLockUser | null) => void;
  clearSession: () => void;
  setFirebaseReady: (ready: boolean) => void;
};

const AppSessionContext = createContext<AppSessionState | null>(null);

export const useAppSession = () => {
  const ctx = useContext(AppSessionContext);
  if (!ctx) {
    throw new Error('useAppSession must be used within AppSessionProvider');
  }
  return ctx;
};

export const AppSessionProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [status, setStatus] = useState<SessionStatus>('loading');
  const [user, setUser] = useState<SpotLockUser | null>(null);
  const [firebaseReady, setFirebaseReady] = useState(false);

  const setSession = (newStatus: SessionStatus, newUser: SpotLockUser | null) => {
    setStatus(newStatus);
    setUser(newUser);
  };

  const clearSession = () => {
    setStatus('unauthenticated');
    setUser(null);
  };

  return (
    <AppSessionContext.Provider value={{ status, user, firebaseReady, setSession, clearSession, setFirebaseReady }}>
      {children}
    </AppSessionContext.Provider>
  );
};
